var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrugCircleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8153 27.4707C41.8153 35.1966 35.4689 41.4707 27.6265 41.4707C19.7841 41.4707 13.4376 35.1966 13.4376 27.4707C13.4376 19.7448 19.7841 13.4707 27.6265 13.4707C35.4689 13.4707 41.8153 19.7448 41.8153 27.4707Z",
    stroke: "#F16576"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6277 39.9707C34.6212 39.9707 40.2905 34.3743 40.2905 27.4707C40.2905 20.5671 34.6212 14.9707 27.6277 14.9707C20.6342 14.9707 14.9649 20.5671 14.9649 27.4707C14.9649 34.3743 20.6342 39.9707 27.6277 39.9707Z",
    stroke: "#F16576",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9678 27.4707C53.9678 41.824 42.1788 53.4707 27.6226 53.4707C13.0665 53.4707 1.27747 41.824 1.27747 27.4707C1.27747 13.1174 13.0665 1.4707 27.6226 1.4707C42.1788 1.4707 53.9678 13.1174 53.9678 27.4707Z",
    stroke: "#F16576"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.624 51.9707C41.3312 51.9707 52.4431 41.0017 52.4431 27.4707C52.4431 13.9397 41.3312 2.9707 27.624 2.9707C13.9168 2.9707 2.80487 13.9397 2.80487 27.4707C2.80487 41.0017 13.9168 51.9707 27.624 51.9707Z",
    stroke: "#F16576",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrugCircleRed);
export default __webpack_public_path__ + "static/media/drug-circle-red.b1a349abe07e2d16b944ca608a7b9ded.svg";
export { ForwardRef as ReactComponent };